<template>
  <transition name="slide-vertical">
    <li
      class="buttons_stacked"
      :class="{
        showMe: showMe,
        hideUnselectedTimes: hideUnselectedTimes,
        selected_time: totalParticipants,
        not_selected_time: !totalParticipants,
      }"
      v-if="showMe"
    >
      <!-- <pre>time.Rates: {{time.Rates.length}}</pre>
    <pre>time.TotalAvailable: {{time.TotalAvailable}}</pre>
    <pre>time.AddOnsSkipped: {{time.AddOnsSkipped}}</pre>
      <pre>time.TotalAvailable: {{time.TotalAvailable}}</pre>-->
      <!-- <pre>showMe: {{showMe}}</pre>
      -->

      <section
        href="#"
        class="flex button -outline -time_o"
        style="position: relative;"
        :class="{
          cursor_normal: time.IsSoldOut,
          'outline selected': totalParticipants && time.IsSelected,
          time_o: !totalParticipants || !time.IsSelected,
        }"
      >
        <hgroup class="mr-1">
          <div>
            <pre>this.totalParticipants: {{ this.totalParticipants }}</pre>
            <pre>time.IsSelected {{ time.IsSelected }}</pre>
            <pre>activity.HideSpotsLeftUntilLessThan: {{ activity.HideSpotsLeftUntilLessThan }}</pre>
            <pre>time.TotalAvailable {{ time.TotalAvailable }}</pre>
            <span class="time -redraw">
              <div class="flex_start">
                <i v-if="hasPickupLocations" style="margin-top: -13px;" class="material-icons">directions_bus</i>
                <span>{{ time.DisplayName }}</span>
              </div>
            </span>
            <span v-if="time.Description" class="text-blue time_slot_description">{{ time.Description }}</span>
            <small class="time_slot_subtotal">
              <sub-total-tool-tip :time="time" v-if="time.IsSelected" />

              <span v-if="timeSubtotal && time.IsSelected">&nbsp;<currency :value="timeSubtotal" /> </span>

              <span v-if="!activity.HideSpotsLeftUntilLessThan || time.TotalAvailable < activity.HideSpotsLeftUntilLessThan">
                <span v-if="timeSubtotal && time.IsSelected">&nbsp;&nbsp;• </span>
                only {{ time.TotalAvailable }} spot{{ time.TotalAvailable != 1 ? "s" : "" }}
                left
              </span>
            </small>
            <!-- <pre>time.AddOns: {{time.AddOns}}</pre> -->
            <!-- <div class="time_addons" v-if="time.AddOns">
            <span
              v-for="(addon,i) in time.AddOns"
              :key="'large-group-times-row-'+i"
              v-show="addon.Quantity>0 && totalParticipants"
            >• {{addon.AddOnName}}&nbsp;</span>
            </div>-->
            <pre>time.ShowSoldOutTimes: {{ time.ShowSoldOutTimes }}</pre>
            <pre>time.IsSoldOut: {{ time.IsSoldOut }}</pre>
            <pre>time.CallToBook: {{ time.CallToBook }}</pre>
          </div>
        </hgroup>
        <!-- <div>
        <span class="button blue small">Book</span>
        </div>-->
        <div v-if="time.CallToBook">
          <call-to-book />
        </div>
        <div v-else-if="time.ShowSoldOutTimes && time.IsSoldOut">
          <small class="text-gray" style="font-size: 14px; font-weight: 500;">Sold out</small>
        </div>
        <div v-else>
          <button
            v-if="totalParticipants && !enableRateDuration"
            @click.prevent="clearSelectedTime()"
            class="button link tiny pl-0 pr-0 text-right no_focus"
          >
            Clear time
          </button>

          <span v-else>
            <button
              @click.prevent="clearSelectedTime()"
              class="button link tiny pl-0 pr-0 text-right no_focus"
              v-if="hideUnselectedTimes && totalParticipants && time.IsSelected"
            >
              Change time
            </button>

            <router-link
              v-else
              class="button small"
              style="text-align: right;  color: white;"
              :class="{
                blue: !totalParticipants || !time.IsSelected,
                'button link tiny pl-0 pr-0 text-right text-blue': totalParticipants && time.IsSelected,
              }"
              :to="'large/' + entityHierarchyKey + '/' + value"
              activeClass="active"
            >
              <span v-if="!totalParticipants || !time.IsSelected">{{
                enableRateDuration ? "Book" : "Add " + (activity.OverrideRateLabel ? activity.RateLabelPlural : "guests")
              }}</span>
              <span v-else>Selected</span>
            </router-link>
          </span>
        </div>
      </section>

      <router-link
        v-if="totalParticipants && time.IsSelected"
        class="button _small large"
        style
        :class="{
          blue: !totalParticipants,
          outline: totalParticipants,
          selected: totalParticipants,
        }"
        :to="'large/' + entityHierarchyKey + '/' + value"
        activeClass="active"
      >
        <span class="flex hgroup">
          <span>
            {{ totalParticipants }}
            {{
              activity.OverrideRateLabel
                ? totalParticipants == 1
                  ? activity.RateLabelSingular
                  : activity.RateLabelPlural
                : totalParticipants != 1
                ? "guests"
                : "guest"
            }}
            <span v-if="totalParticipants > time.TotalAvailable"> </span>
          </span>
          <small class="text-blue">Edit</small>
        </span>
      </router-link>

      <router-link
        v-if="totalParticipants && hasPickupLocations && time.IsSelected"
        class="button outline pickup-location-ui"
        :class="{
          'small selected': time.PickupLocation,
          large: !time.PickupLocation,
        }"
        :to="'transportation/' + entityHierarchyKey + '/' + time.Value"
      >
        <span v-if="time.PickupLocation" class="flex hgroup">
          <span>
            {{ time.PickupLocation.LocationName }}
            <br />
            <small>{{ time.PickupLocation.DepartureDisplayTime }} pick-up</small>
            <small>{{ time.PickupLocation.DistanceFromHotel }} miles from your hotel</small>
          </span>
          <small class="text-blue">Edit</small>
        </span>
        <span v-else class="flex">
          <span class="text-blue">Select pick-up location</span>
        </span>
      </router-link>

      <router-link
        v-if="totalParticipants && time.IsSelected && time.AddOns && time.AddOns.length"
        class="button outline pickup-location-ui small selected"
        :to="'addons/' + entityHierarchyKey + '/' + time.Value"
      >
        <span v-if="addOnsHaveQuantity" class="flex hgroup">
          <span>
            Add-ons
            <br />
            <span class="hide_last_comma">
              <small v-show="addon.Quantity" v-for="(addon, i) in time.AddOns" :key="'large-times-ui-row-' + time.Value + '-' + i"
                >{{ addon.AddOnName }}&nbsp;
                {{ addon.IsBoolean ? "" : " x " + addon.Quantity }}
              </small>
            </span>
          </span>
          <small class="text-blue">Edit</small>
        </span>
        <span v-else class="flex hgroup">
          <span
            >Add-ons
            <br />
            <small>None selected</small>
          </span>
          <small class="text-blue">Edit</small>
        </span>
      </router-link>

      <!-- <pre>timeSlotRequirements: {{timeSlotRequirements}}</pre> -->
      <!-- <pre>time.Rates: {{time.Rates}}</pre> -->
    </li>
  </transition>
</template>

<script>
//import postTimeSelection from "../mixins/postTimeSelection.js";
//import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

// components
import SubTotalToolTip from "./SubTotalToolTip.vue";

export default {
  name: "LargeGroupTimesUiRow",
  props: ["time", "name", "id", "value", "entityHierarchyKey", "enableRateDuration", "hideUnselectedTimes", "activity", "isLoading"],
  components: {
    SubTotalToolTip,
  },
  data: function() {
    return {
      //style: "opacity: 1"
    };
  },

  //mixins: [postTimeSelection],

  // watch: {
  //   "time.IsSelected": {
  //     handler: function(newVal) {
  //       //console.log(newVal + " - " + oldVal);
  //       if (newVal == true) {
  //         this.style = "opacity:1;";
  //       } else {
  //         //this.style = "opacity:.8;";
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    //...mapActions(["clearSelectedTime"]),

    clearSelectedTime() {
      //console.log("clearSelectedTime()");
      // record this time in the clearedTimes array for later use.
      if (!this.activity.clearedTimes) {
        this.$set(this.activity, "clearedTimes", []);
      }
      this.activity.clearedTimes.push(this.time);

      //console.log("this.activity.clearedTimes", this.activity.clearedTimes);

      this.time.Rates.forEach((rate) => {
        //rate.Participants = 0;
        this.$set(rate, "Participants", 0);
      });
      this.time.AddOns.forEach((add) => {
        ///add.Quantity = 0;
        this.$set(add, "Quantity", 0);
      });

      this.$set(this.time, "IsSelected", false);
      this.$set(this.time, "PickupLocation", null);

      this.time.PickupLocations.forEach((location) => {
        //location.IsSelected = false;
        this.$set(location, "IsSelected", false);
      });

      // need to clear time for the TimesClone
      let findTimeClone = this.activity.TimesClone.find((ele) => {
        return ele.Value === this.time.Value;
      });

      if (findTimeClone) {
        findTimeClone.Rates.forEach((rate) => {
          //rate.Participants = 0;
          this.$set(rate, "Participants", 0);
        });
        findTimeClone.AddOns.forEach((add) => {
          this.$set(add, "Quantity", 0);
        });

        this.$set(findTimeClone, "IsSelected", false);
        this.$set(findTimeClone, "PickupLocation", null);

        findTimeClone.PickupLocations.forEach((location) => {
          this.$set(location, "IsSelected", false);
        });
      }
      //this.$emit("showUnselectedTimes", {});
    },

    updateInput: function(event) {
      this.$emit("input", event.target.value);
    },
  },

  computed: {
    showMe() {
      return !this.hideUnselectedTimes || this.totalParticipants > 0;
    },
    timeSubtotal() {
      var total = 0;

      this.time.Rates.forEach((rate) => {
        total = total + rate.Participants * (rate.SlashThroughPrice ? rate.SlashThroughPrice : rate.Price);
      });

      this.time.AddOns.forEach((addon) => {
        // addon
        //addon.forEach(ad);
        const subTract = addon.AddOnDiscount ? addon.AddOnDiscount : 0;
        total += addon.Quantity * (addon.PublishedPrice - subTract);
      });

      return total;
    },

    addOnsHaveQuantity() {
      var f = this.time.AddOns.find((ele) => {
        return ele.Quantity > 0;
      });

      if (f) {
        return true;
      }
      return false;
    },
    hasPickupLocations() {
      return this.time.PickupLocations.length;
    },
    totalParticipants() {
      let c = 0;
      if (this.time.Rates && this.time.IsSelected) {
        this.time.Rates.forEach((ele) => {
          //alert(ele.Participants);
          if (!ele.IsPrivateTourRate) {
            c = c + ele.Participants;
          }
        });
      }

      return c;
    },
  },
};
</script>

<style>
.hide_last_comma :last-child .comma {
  display: none;
}
</style>
